import { Info } from "lucide-react";

/**
 * Small inline disclaimer used directly under live calculation outputs
 * (calculator, snapshot results) so users always see context for figures.
 */
const Microdisclaimer = ({ children, className = "" }) => (
  <p className={`mt-3 inline-flex items-center gap-1.5 text-[11px] text-[#475569] leading-relaxed ${className}`}>
    <Info className="w-3 h-3 shrink-0 text-[#0F766E]" />
    <span>{children || "Estimates only. Not a mortgage offer, recommendation, or regulated advice."}</span>
  </p>
);

export default Microdisclaimer;
